/**
 * Display form of the customer's **Online card number** (the Open24 identifier
 * shown in the ID&V banner, CCF-3/SCRN-43).
 *
 * The gateway's `customer/identification` / `customer/search` ops return the
 * online card as the full **16-digit `OnlineCardNbr`** — a fixed `503585`
 * Maestro BIN prefix + the **10-digit Open24 number** (issue #77). The Open24
 * number is the meaningful identifier; the BIN prefix is not part of it, and the
 * authoritative dashboard figma depicts the banner field as the 10-digit value
 * (`Online card number: 1234567890`). The BFF already reduces the 16-digit form
 * to its trailing 10 for every servicing call (`toServicingCardNumber`); this is
 * the display-side counterpart so the banner shows the same Open24 number rather
 * than the full 16 digits (issue #191).
 *
 * A digit string longer than 10 is reduced to its trailing 10 (the Open24
 * suffix). Values that are already ≤10 digits (the agent-entered Open24 card on
 * the in-call ID&V path; the mock's 10-digit numbers) and non-card sentinels
 * (e.g. the `"N/A"` placeholder when the customer has no card on file) are
 * returned unchanged, so this is a no-op on those paths and only corrects the
 * 16-digit search-bound case.
 *
 * NOTE: this is distinct from PAN masking (`maskCardDisplay`). The Online card
 * number is an Open24 identifier the agent needs in full (10 digits) and is the
 * one card value shown unmasked; physical card PANs are masked separately.
 */
export function onlineCardDisplay(card: string): string {
  const digits = card.replace(/\D/g, '');
  if (digits.length > 10) {
    return digits.slice(-10);
  }
  return card;
}
